import { BaseApi } from './BaseApi';
export class FlowApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getFlow(id, withRelatedEntities) {
        return this.providers.makeRequest({
            route: this.buildRoute('flow'),
            params: {
                id,
                withRelatedEntities,
            },
        });
    }
    getFlows() {
        return this.providers.makeRequest({
            route: this.buildRoute('flows'),
            method: 'GET',
        });
    }
}
//# sourceMappingURL=flowApi.js.map